export default __webpack_public_path__ + "static/media/logo-geral-agencia.f8996a4e.png";